import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoLightbulb = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Lightbulb</title>
    <path
      d="M11.757 22.982c-.438-1.882-1.165-2.984-2.164-4.658-1.569-2.629-2.353-4.342-2.353-7.226a8.76 8.76 0 0 1 17.519 0c0 2.818-.785 4.597-2.353 7.226-.993 1.663-1.718 2.754-2.157 4.624-.265 1.132-2.88 1.714-4.268 1.714-1.645 0-3.965-.569-4.224-1.68Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.064 6.957a3.048 3.048 0 0 1 3.047 3.048M18.909 27.756c-.814.266-1.846.425-2.969.425-1.263 0-2.412-.201-3.264-.53M18.322 31.262c-.66.234-1.498.374-2.41.374-1.026 0-1.958-.177-2.65-.466"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoLightbulb;
